import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, TitleHeader } from 'web-library';
import ViewDetails from '../../../modules/transaction/@coordinator/ViewDetails';

const ViewDetailsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('transaction->>Page.Header.ViewDetails')} />

      <ContentTemplate type="full">
        <ViewDetails />
      </ContentTemplate>
    </>
  );
};

export default ViewDetailsPage;
